/*(c) Copyright 2015 Pivotal Software, Inc. All Rights Reserved.*/
'use strict';

function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
}

module.exports = {
  getScrollTop: function getScrollTop() {
    return isFirefox() ? document.documentElement.scrollTop : document.body.scrollTop;
  },

  setScrollTop: function setScrollTop(value) {
    document.body.scrollTop = value;
    document.documentElement.scrollTop = value;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/scroll-top.js
 ** module id = 317
 ** module chunks = 0
 **/